import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Doctors = () => {
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedSpecialty, setSelectedSpecialty] = useState('all');

    // Mock data for doctors
    useEffect(() => {
        // Simulate loading doctor data
        setTimeout(() => {
            setDoctors([
                {
                    id: 1,
                    name: 'Dr. Ioan Dumitrescu',
                    email: 'ioan.dumitrescu@evoomedical.ro',
                    phone: '+40 21 123 4567',
                    specialty: 'Medicină Internă',
                    experience: 15,
                    status: 'active'
                },
                {
                    id: 2,
                    name: 'Dr. Elena Marinescu',
                    email: 'elena.marinescu@evoomedical.ro',
                    phone: '+40 21 234 5678',
                    specialty: 'Cardiologie',
                    experience: 12,
                    status: 'active'
                },
                {
                    id: 3,
                    name: 'Dr. Mihai Constantinescu',
                    email: 'mihai.constantinescu@evoomedical.ro',
                    phone: '+40 21 345 6789',
                    specialty: 'Radiologie',
                    experience: 8,
                    status: 'active'
                },
                {
                    id: 4,
                    name: 'Dr. Ana Popescu',
                    email: 'ana.popescu@evoomedical.ro',
                    phone: '+40 21 456 7890',
                    specialty: 'Pediatrie',
                    experience: 10,
                    status: 'on_leave'
                }
            ]);
            setLoading(false);
        }, 1000);
    }, []);

    const specialties = ['all', 'Medicină Internă', 'Cardiologie', 'Radiologie', 'Pediatrie', 'Dermatologie', 'Oftalmologie'];

    const filteredDoctors = selectedSpecialty === 'all'
        ? doctors
        : doctors.filter(doctor => doctor.specialty === selectedSpecialty);

    return (
        <div className="doctors-page">
            <div className="page-navigation-header">
                <div className="nav-header-content">
                    <NavLink to="/dashboard" className="back-to-dashboard">
                        ← Înapoi la Dashboard
                    </NavLink>
                    <div className="quick-nav">
                        <NavLink to="/patients" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Pacienți
                        </NavLink>
                        <NavLink to="/appointments" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Programări
                        </NavLink>
                        <NavLink to="/reports" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Rapoarte
                        </NavLink>
                    </div>
                </div>
            </div>

            <div className="page-header">
                <h1>Gestionare Doctori</h1>
                <p>Administrarea informațiilor despre doctori și specializările lor</p>
            </div>

            <div className="controls-section">
                <div className="filter-section">
                    <label htmlFor="specialty-filter">Filtrează după specializare:</label>
                    <select
                        id="specialty-filter"
                        value={selectedSpecialty}
                        onChange={(e) => setSelectedSpecialty(e.target.value)}
                        className="specialty-select"
                    >
                        <option value="all">Toate Specializările</option>
                        {specialties.slice(1).map(specialty => (
                            <option key={specialty} value={specialty}>
                                {specialty}
                            </option>
                        ))}
                    </select>
                </div>
                <button className="add-doctor-btn">Adaugă Doctor Nou</button>
            </div>

            <div className="doctors-stats">
                <div className="stat-card">
                    <h3>Total Doctori</h3>
                    <div className="stat-number">{doctors.length}</div>
                </div>
                <div className="stat-card">
                    <h3>Activi</h3>
                    <div className="stat-number">{doctors.filter(doctor => doctor.status === 'active').length}</div>
                </div>
                <div className="stat-card">
                    <h3>În Concediu</h3>
                    <div className="stat-number">{doctors.filter(doctor => doctor.status === 'on_leave').length}</div>
                </div>
                <div className="stat-card">
                    <h3>Specializări</h3>
                    <div className="stat-number">{specialties.length - 1}</div>
                </div>
            </div>

            <div className="doctors-table-container">
                {loading ? (
                    <div className="loading">Se încarcă lista doctorilor...</div>
                ) : (
                    <table className="doctors-table">
                        <thead>
                            <tr>
                                <th>Nume</th>
                                <th>Specializare</th>
                                <th>Email</th>
                                <th>Telefon</th>
                                <th>Experiență (ani)</th>
                                <th>Status</th>
                                <th>Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredDoctors.map(doctor => (
                                <tr key={doctor.id}>
                                    <td>{doctor.name}</td>
                                    <td>{doctor.specialty}</td>
                                    <td>{doctor.email}</td>
                                    <td>{doctor.phone}</td>
                                    <td>{doctor.experience}</td>
                                    <td>
                                        <span className={`status-badge ${doctor.status}`}>
                                            {doctor.status === 'active' ? 'Activ' : 'În Concediu'}
                                        </span>
                                    </td>
                                    <td>
                                        <button className="view-btn">Vezi Profil</button>
                                        <button className="edit-btn">Editează</button>
                                        <button className="schedule-btn">Program</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <style jsx>{`
                .doctors-page {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 2rem;
                }

                .page-header {
                    margin-bottom: 2rem;
                }

                .page-header h1 {
                    color: #333;
                    margin-bottom: 0.5rem;
                }

                .page-header p {
                    color: #666;
                }

                .controls-section {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 2rem;
                    gap: 1rem;
                }

                .filter-section {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                }

                .filter-section label {
                    font-weight: 500;
                    color: #333;
                }

                .specialty-select {
                    padding: 0.5rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    font-size: 1rem;
                }

                .add-doctor-btn {
                    padding: 0.75rem 1.5rem;
                    background: #667eea;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: background 0.3s;
                }

                .add-doctor-btn:hover {
                    background: #5a67d8;
                }

                .doctors-stats {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 1rem;
                    margin-bottom: 2rem;
                }

                .stat-card {
                    background: white;
                    padding: 1.5rem;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    border-left: 4px solid #667eea;
                }

                .stat-card h3 {
                    margin: 0 0 0.5rem 0;
                    color: #666;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    font-weight: 600;
                }

                .stat-number {
                    font-size: 2rem;
                    font-weight: bold;
                    color: #333;
                }

                .doctors-table-container {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    overflow: hidden;
                }

                .loading {
                    text-align: center;
                    padding: 3rem;
                    color: #666;
                }

                .doctors-table {
                    width: 100%;
                    border-collapse: collapse;
                }

                .doctors-table th,
                .doctors-table td {
                    padding: 1rem;
                    text-align: left;
                    border-bottom: 1px solid #f0f0f0;
                }

                .doctors-table th {
                    background: #f8f9fa;
                    font-weight: 600;
                    color: #333;
                }

                .doctors-table tbody tr:hover {
                    background: #f8f9fa;
                }

                .status-badge {
                    padding: 0.25rem 0.75rem;
                    border-radius: 4px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    text-transform: uppercase;
                }

                .status-badge.active {
                    background: #d4edda;
                    color: #155724;
                }

                .status-badge.on_leave {
                    background: #fff3cd;
                    color: #856404;
                }

                .view-btn,
                .edit-btn,
                .schedule-btn {
                    padding: 0.4rem 0.8rem;
                    margin-right: 0.3rem;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 0.9rem;
                    transition: background 0.3s;
                }

                .view-btn {
                    background: #28a745;
                    color: white;
                }

                .view-btn:hover {
                    background: #218838;
                }

                .edit-btn {
                    background: #ffc107;
                    color: #212529;
                }

                .edit-btn:hover {
                    background: #e0a800;
                }

                .schedule-btn {
                    background: #17a2b8;
                    color: white;
                }

                .schedule-btn:hover {
                    background: #138496;
                }

                .page-navigation-header {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-bottom: 2rem;
                    padding: 1rem;
                }

                .nav-header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 1rem;
                }

                .back-to-dashboard {
                    color: #667eea;
                    text-decoration: none;
                    font-weight: 500;
                    padding: 0.5rem 1rem;
                    border-radius: 4px;
                    transition: background 0.3s;
                }

                .back-to-dashboard:hover {
                    background: #f8f9fa;
                }

                .quick-nav {
                    display: flex;
                    gap: 1rem;
                }

                .quick-nav-link {
                    padding: 0.5rem 1rem;
                    color: #666;
                    text-decoration: none;
                    border-radius: 4px;
                    font-weight: 500;
                    transition: all 0.3s;
                }

                .quick-nav-link:hover, .quick-nav-link.active {
                    background: #667eea;
                    color: white;
                }

                @media (max-width: 768px) {
                    .controls-section {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .filter-section {
                        justify-content: center;
                    }

                    .nav-header-content {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .quick-nav {
                        justify-content: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default Doctors;
